import { useCallback, useEffect, useState } from "react";
import { api, fmtErr, fmtDateTime } from "../../lib/api";
import { toast } from "sonner";
import { Inbox, MailOpen } from "lucide-react";

export default function AdminReports() {
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState("");

  const load = useCallback(() => {
    api.get("/admin/reports").then((r) => setRows(r.data)).catch(() => setRows([]));
  }, []);
  useEffect(load, [load]);

  const toggleRead = async (id) => {
    if (busy) return;
    setBusy(id);
    try {
      await api.post(`/admin/reports/${id}/read`);
      load();
    } catch (e) {
      toast.error(fmtErr(e));
    } finally {
      setBusy("");
    }
  };

  return (
    <div data-testid="admin-reports-section">
      <h2 className="font-display text-2xl text-amber-100 mb-2">Segnalazioni</h2>
      <p className="text-xs text-purple-300/60 mb-6">
        Problemi segnalati dalle utenti. Le segnalazioni non generano rimborsi né modifiche automatiche: verifichi tu ogni caso.
      </p>
      {rows === null ? null : rows.length === 0 ? (
        <div className="mystic-card p-10 text-center" data-testid="admin-reports-empty">
          <Inbox className="w-8 h-8 text-amber-400/50 mx-auto mb-3" />
          <p className="text-purple-200/60 text-sm">Nessuna segnalazione ricevuta.</p>
        </div>
      ) : (
        <div className="space-y-3" data-testid="admin-reports-list">
          {rows.map((r) => (
            <div key={r.id} className="mystic-card p-5" data-testid={`admin-report-${r.id}`}>
              <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs mb-2">
                <span className="text-amber-200" data-testid={`admin-report-email-${r.id}`}>{r.email}</span>
                <span className="text-purple-300/50">{fmtDateTime(r.created_at)}</span>
                <span
                  className={`ml-auto text-[10px] uppercase tracking-wider border rounded-full px-2 py-0.5 ${r.status === "letta" ? "border-purple-500/40 text-purple-300/50" : "border-amber-500/50 text-amber-300"}`}
                  data-testid={`admin-report-status-${r.id}`}
                >
                  {r.status === "letta" ? "Letta" : "Nuova"}
                </span>
              </div>
              <p className="text-sm text-purple-100/85 whitespace-pre-wrap leading-relaxed" data-testid={`admin-report-text-${r.id}`}>{r.message}</p>
              <button
                onClick={() => toggleRead(r.id)}
                disabled={busy === r.id}
                data-testid={`admin-report-read-${r.id}`}
                className="mt-3 text-xs text-purple-200 border border-[#4a2175] rounded-full px-4 py-1.5 hover:bg-purple-500/10 transition-colors disabled:opacity-50 inline-flex items-center gap-1.5"
              >
                <MailOpen className="w-3.5 h-3.5" /> {r.status === "letta" ? "Segna come nuova" : "Segna come letta"}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
